/**
 * Utilities to get the width of some string rendered in the browser.
 * Based off of https://stackoverflow.com/a/21015393/3124288
 */

let canvas: HTMLCanvasElement | null;

export const measureText = (
  textToMeasure: string,
  fontStyle: string,
): number | undefined => {
  canvas ??= document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return undefined;
  context.font = fontStyle;
  const metrics = context.measureText(textToMeasure);
  return metrics?.width;
};

export const getFontStyle = (ele: HTMLElement): string | undefined => {
  const computedStyles = window.getComputedStyle(ele);
  const fontWeight = computedStyles.getPropertyValue("font-weight");
  const fontSize = computedStyles.getPropertyValue("font-size");
  const fontFamily = computedStyles.getPropertyValue("font-family");

  if (!fontWeight || !fontSize || !fontFamily) {
    return undefined;
  }

  return `${fontWeight} ${fontSize} ${fontFamily}`;
};
